export enum EServiceChangeRequestComparator {
  EQ = 'EQ',
  GT = 'GT',
  GTE = 'GTE',
  LT = 'LT',
  LTE = 'LTE',
  NEQ = 'NEQ',
  CONTAINS = 'CONTAINS',
}
